import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@Component({
    selector: 'app-abbr',
    standalone: true,
    imports: [CommonModule, MatTooltipModule],
    templateUrl: './abbr.component.html',
    styleUrls: ['./abbr.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbbrComponent {
    constructor() {}

    @Input() title: string;
}
